import { SplashScreenService } from './shared/splashScreen/splash-screen.service';
import {
  Router,
  NavigationStart,
  ActivatedRoute,
  RouteConfigLoadStart,
  RouteConfigLoadEnd,
  NavigationCancel,
  NavigationEnd
} from '@angular/router';
import { Component, ChangeDetectorRef, OnInit, ViewChild, ElementRef, AfterViewInit, Renderer2, computed, effect } from '@angular/core';
import { filter, map, mergeMap } from 'rxjs/operators';
import { TitleService } from './shared/title-service/title.service';


import { environment } from '../environments/environment';
import { UserService } from './services/userService/user.service';
import { HamburgerStateService } from './theme/hamburger-state.service';
import { RoutingService } from './services/routingService/routing.service';
import { ScrollService } from './services/scroll.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'apptp-frontend';
  @ViewChild('splashScreen', { read: ElementRef })
  splashScreen: ElementRef;
  splashScreenImage: string;
  isLoggedIn = computed(() => this.hamburgerService.isUserLoggedIn());
  decode;
  constructor(
    private router: Router,
    private routerService: RoutingService,
    private sharedService: UserService,
    private activatedRoute: ActivatedRoute,
    private _ref: ChangeDetectorRef,
    private splashScreenService: SplashScreenService,
    private _titleService: TitleService,
    private renderer: Renderer2,
    private hamburgerService: HamburgerStateService,
    private scrollService: ScrollService
  ) {
    // page progress bar percentage
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        // set page progress bar loading to end on NavigationEnd event router
        // window.scrollTo(0, 0);
        this.scrollService.scrollToTop();
        this._ref.markForCheck();
      }
      if (event instanceof NavigationEnd) {
        if ((<any>window).ga) {
          (<any>window).ga('create', environment.ga_token, 'auto');
          (<any>window).ga('set', 'page', event.urlAfterRedirects);
          (<any>window).ga('send', 'pageview');
        }
      }
    });
    effect(() => {
      this.updateBodyHeightToKeepFooterAtBottom();
    });
  }

  ngOnInit() {
    this.decode = this.routerService.decodeToken();
    this.hamburgerService.isUserLoggedIn.set(this.decode);
    // window.scrollTo(0, 0);
    this.scrollService.scrollToTop();
    this._titleService.updateTitle();
    this.updateBodyHeightToKeepFooterAtBottom();
  }

  updateBodyHeightToKeepFooterAtBottom() {
    const styleId = 'guest-style';
  
    if (!this.isLoggedIn()) {
      console.log('User is not logged in');
  
      // Check if the style already exists
      if (!document.getElementById(styleId)) {
        const style = this.renderer.createElement('style');
        style.id = styleId;
        style.innerHTML = `
          html, body {
            height: 100%;
            margin: 0;
          }
        `;
        this.renderer.appendChild(document.head, style);
      }
    } else {
      console.log('User is logged in');
  
      // Remove the style if it exists
      const existingStyle = document.getElementById(styleId);
      if (existingStyle) {
        this.renderer.removeChild(document.head, existingStyle);
      }
    }
  }
  

  ngAfterViewInit(): void {
    if (this.splashScreen) {
      this.splashScreenService.init(this.splashScreen.nativeElement);
    }
  }

}
